/**
 * themeStore — persists light/dark theme preference.
 */
import { create } from 'zustand'

type Theme = 'dark' | 'light'

interface ThemeState {
  theme: Theme
  toggleTheme: () => void
  setTheme: (t: Theme) => void
}

const saved = (localStorage.getItem('dukkan_theme') as Theme) || 'dark'

export const useThemeStore = create<ThemeState>((set) => ({
  theme: saved,
  setTheme: (theme) => {
    localStorage.setItem('dukkan_theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
    set({ theme })
  },
  toggleTheme: () => {
    set((s) => {
      const next: Theme = s.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem('dukkan_theme', next)
      document.documentElement.setAttribute('data-theme', next)
      return { theme: next }
    })
  },
}))

// Apply theme on load
document.documentElement.setAttribute('data-theme', saved)
